import React, { useEffect, useMemo, useState } from "react";
import "./SellerBankAccount.css";
import axios from "axios";
import SellerServicesUrl from "../../SellerServicesUrl";
import Select from "react-select";
import countryList from "react-select-country-list";
import { BaseUrl } from "../../App";


export default function SellerBankAccount() {
  const [beneficiaryType, setBeneficiaryType] = useState("individual");
  const [loaded, setLoaded] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
const [successMsg, setSuccessMsg] = useState("");

 const [isSubmitted, setIsSubmitted] = useState(
   localStorage.getItem("bankSubmitted") === "true"
 );
// const [isSubmitted, setIsSubmitted] = useState(false);
  const beneficiaryOptions = [
    { value: "individual", label: "فرد" },
    { value: "company", label: "شركة" },
  ];

  const [bankName, setBankName] = useState("");
  const [bankImage, setBankImage] = useState(null);

  const [iban, setIban] = useState("");
  const [swiftCode, setSwiftCode] = useState("");
  const [accountHolder, setAccountHolder] = useState("");
  const [mobile, setMobile] = useState("");
  const [country, setCountry] = useState(null);
// const [showNoChanges, setShowNoChanges] =
//   useState(false);

// const [originalAccountNumber] =
//   useState(accountNumber);

// const [showSuccessModal, setShowSuccessModal] =
//   useState(false);
// const [accountNumber, setAccountNumber] = useState("54127841254699");
const [accountNumber, setAccountNumber] =
  useState(
    Math.floor(
      10000000000000 +
      Math.random() * 90000000000000
    ).toString()
);

const [originalAccountNumber, setOriginalAccountNumber] =
  useState(accountNumber);

const [showNoChanges, setShowNoChanges] =
  useState(false);

const [showSuccessModal, setShowSuccessModal] =
  useState(false);
  const [isSwift, setIsSwift] = useState(false);

  const [errors, setErrors] = useState({});

  // ================= COUNTRY =================
  const countryOptions = useMemo(() => {
    const list = countryList().getData();

    const dn = new Intl.DisplayNames(["ar"], {
      type: "region",
    });

    return list
      .map((c) => ({
        value: c.value,
        label: dn.of(c.value) || c.label,
      }))
      .sort((a, b) => a.label.localeCompare(b.label, "ar"));
  }, []);
//   useEffect(() => {
//   const submitted =
//     localStorage.getItem("bankSubmitted");

//   if (submitted === "true") {
//     setIsSubmitted(true);
//   }
// }, []);

  // ================= VALIDATION =================

//   const validateBankName = (value) => {
//     if (!value.trim()) return "اسم البنك مطلوب";

//     if (value.trim().length < 3) {
//       return "اسم البنك يجب أن يكون ٣ أحرف على الأقل";
//     }

//     if (/\d/.test(value)) {
//       return "اسم البنك لا يجب أن يحتوي على أرقام";
//     }

//     return "";
//   };

//   const validateIban = (value) => {
//     const ibanClean = value.replace(/\s+/g, "");

//     if (!ibanClean) return "رقم IBAN مطلوب";

// if (!/^[A-Z]{2}\d{18,30}$/.test(ibanClean)){      return "رقم IBAN غير صحيح";
//     }

//     return "";
//   };

//   const validateAccountHolder = (value) => {
//     if (!value.trim()) {
//       return "اسم صاحب الحساب مطلوب";
//     }

//     if (value.trim().split(" ").length < 2) {
//       return "اكتب الاسم كامل (اسمين على الأقل)";
//     }

//     return "";
//   };

//   const validateMobile = (value) => {
//     const phoneDigits = value.replace(/\D/g, "");

//     if (!phoneDigits) return "رقم الجوال مطلوب";

//     if (phoneDigits.length < 8 || phoneDigits.length > 15) {
//       return "رقم الجوال غير صحيح";
//     }

//     return "";
//   };

   const validateAccountNumber = (value) => {
     if (!value.trim()) return "رقم الحساب مطلوب";

     if (!/^\d+$/.test(value)) {
       return "رقم الحساب يجب أن يحتوي على أرقام فقط";
    }

    if (value.length < 8) {
       return "رقم الحساب غير صحيح";
     }

     return "";
  };

  //  const validate = () => {
  // //   let newErrors = {};

  // //   if (!country) {
  // //     newErrors.country = "الدولة مطلوبة";
  // //   }

  // //   const bankNameError = validateBankName(bankName);

  // //   if (bankNameError) {
  // //     newErrors.bankName = bankNameError;
  // //   }

  // //   const ibanError = validateIban(iban);

  // //   if (ibanError) {
  // //     newErrors.iban = ibanError;
  // //   }

  // //   const accountHolderError = validateAccountHolder(accountHolder);

  // //   if (accountHolderError) {
  // //     newErrors.accountHolder = accountHolderError;
  // //   }

  // //   const mobileError = validateMobile(mobile);

  // //   if (mobileError) {
  // //     newErrors.mobile = mobileError;
  // //   }

  // //   // const accountNumberError = validateAccountNumber(accountNumber);

  // //   // if (accountNumberError) {
  // //   //   newErrors.accountNumber = accountNumberError;
  // //   // }

  // //   if (isSwift && !swiftCode.trim()) {
  // //     newErrors.swiftCode =
  // //       "رمز SWIFT مطلوب عند تفعيل التحويل الدولي";
  // //   }

  // //   if (!bankImage) {
  // //     newErrors.bankImage =
  // //       "صورة إثبات الحساب مطلوبة";
  // //   }

  // //   setErrors(newErrors);

  // //   return Object.keys(newErrors).length === 0;
  // };
const validate = () => {
  let newErrors = {};

  const accountNumberError =
    validateAccountNumber(accountNumber);

  if (accountNumberError) {
    newErrors.accountNumber =
      accountNumberError;
  }
  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};
  // ================= SUBMIT =================
  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validate()) return;

  try {

    const formData = new FormData();

    formData.append(
      "account_number",
      accountNumber
    );
    if (
  accountNumber === originalAccountNumber
) {

  setShowNoChanges(true);

  return;
}
console.log(localStorage.getItem("token"));
  const response = await axios.post(
  `${BaseUrl}${SellerServicesUrl.SellerBank}`,
  formData,
  {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      Accept: "application/json",
    },
  }
);
    console.log(response.data);

    // if (response.data.status === 200) {


    //   setShowSuccessModal(true);

    //   setIsEditing(false);

    // }
    if (response.data.status === 200) {

  setOriginalAccountNumber(accountNumber);

  setShowSuccessModal(true);

  setIsEditing(false);

  setShowNoChanges(false);
}

  } catch (error) {

    console.log(error);

  }
};

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validate()) return;

//     try {
//       const formData = new FormData();

//       formData.append("country", country?.label || "");

//       formData.append(
//         "beneficiary_type",
//         beneficiaryType
//       );

//       formData.append("bank_name", bankName);

//        formData.append(
//          "account_number",
//          accountNumber
//        );

//       formData.append(
//         "account_holder",
//         accountHolder
//       );

//       formData.append("mobile", mobile);

//       formData.append(
//         "swift",
//         isSwift ? "1" : "0"
//       );

//       formData.append(
//         "swift_code",
//         swiftCode
//       );

//       formData.append("iban", iban);

//       if (bankImage) {
//         formData.append(
//           "bank_image",
//           bankImage
//         );
//       }
// console.log({
//   accountNumber,
//   iban,
//   swiftCode,
//   mobile,
// });
//       const response = await axios.post(
//         `${BaseUrl}${SellerServicesUrl.SellerBank}`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem(
//               "token"
//             )}`,
//             Accept: "application/json",
//             "Content-Type":
//               "multipart/form-data",
//           },
//         }
//       );

//       console.log("FULL RESPONSE:", response);

//       console.log(
//         "STATUS:",
//         response.status
//       );

//       console.log(
//         "DATA:",
//         response.data
//       );

//       console.log(
//         "MESSAGE:",
//         response.data?.message
//       );

// if (response.data.status === 200) {
//   setSuccessMsg("تم تحديث الحساب البنكي بنجاح");
// setIsEditing(false);
//   setIsSubmitted(true)

//   localStorage.setItem(
//     "bankSubmitted",
//     "true"
//   )
// }
//     } catch (error) {
//       console.log(
//         "ERROR FULL:",
//         error
//       );

//       console.log(
//         "ERROR STATUS:",
//         error.response?.status
//       );

//       console.log(
//         "ERROR DATA:",
//         error.response?.data
//       );

//       console.log(
//         "ERROR MESSAGE:",
//         error.response?.data?.message
//       );
//     }
//   };

  return (
    <div className="profile-wrapper banckaccount container">
      <div className="bank-content mb-3">

        <h1 className="text-center pt-4 pb-3">
          الحساب البنكي
        </h1>

        <form onSubmit={handleSubmit}>

          {/* الدولة */}

          {/* <div className="bank-input">
            <label className="pb-2">
              الدولة
            </label>

            <Select
              options={countryOptions}
              value={country}
              onChange={(value) => {
                setCountry(value);

                setErrors((prev) => ({
                  ...prev,
                  country: "",
                }));
              }}
              placeholder="اختر الدولة"
              isSearchable
            />

            {errors.country && (
              <small className="error-text">
                {errors.country}
              </small>
            )}
          </div> */}

          {/* نوع المستفيد */}

          {/* <div className="bank-input">
            <label className="pb-2">
              نوع المستفيد
            </label>

            <Select
              options={beneficiaryOptions}
              value={beneficiaryOptions.find(
                (opt) =>
                  opt.value === beneficiaryType
              )}
              onChange={(option) =>
                setBeneficiaryType(
                  option.value
                )
              }
              isSearchable={false}
            />
          </div> */}

          {/* اسم البنك */}

          {/* <div className="bank-input">
            <label className="pb-2">
              اسم البنك
            </label>

            <input
              type="text"
              placeholder="ادخل اسم البنك"
              value={bankName}
              onChange={(e) => {
                const value =
                  e.target.value;

                setBankName(value);

                setErrors((prev) => ({
                  ...prev,
                  bankName:
                    validateBankName(
                      value
                    ),
                }));
              }}
            />

            {errors.bankName && (
              <small className="error-text">
                {errors.bankName}
              </small>
            )}
          </div> */}

          {/* رقم الحساب */}

          {/* <div className="bank-input"> */}
            {/* <label className="pb-2">
              رقم الحساب
            </label> */}

            {/* <input
              type="text"
              placeholder="ادخل رقم الحساب"
              value={accountNumber}
              onChange={(e) => {
                const value =
                  e.target.value;

                setAccountNumber(value);

                setErrors((prev) => ({
                  ...prev,
                  accountNumber:
                    validateAccountNumber(
                      value
                    ),
                }));
              }}
            /> */}

            {/* {errors.accountNumber && (
              <small className="error-text">
                {errors.accountNumber}
              </small>
            )} */}
          {/* </div> */}

          {/* اسم صاحب الحساب */}

          {/* <div className="bank-input">
            <label className="pb-2">
              اسم صاحب الحساب
            </label>

            <input
              type="text"
              placeholder="ادخل الاسم الكامل كما هو مسجل في البنك"
              value={accountHolder}
              onChange={(e) => {
                const value =
                  e.target.value;

                setAccountHolder(value);

                setErrors((prev) => ({
                  ...prev,
                  accountHolder:
                    validateAccountHolder(
                      value
                    ),
                }));
              }}
            />

            {errors.accountHolder && (
              <small className="error-text">
                {errors.accountHolder}
              </small>
            )}
          </div> */}

          {/* SWIFT */}

          {/* <div className="bank-input">

            <div className="swift-row">

              <span className="swift-text">
                تحويل دولي (يتطلب SWIFT)
              </span>

              <label className="switch">

                <input
                  type="checkbox"
                  checked={isSwift}
                  onChange={() => {
                    const newValue =
                      !isSwift;

                    setIsSwift(newValue);

                    if (!newValue) {
                      setSwiftCode("");

                      setErrors(
                        (prev) => ({
                          ...prev,
                          swiftCode: "",
                        })
                      );
                    }
                  }}
                />

                <span className="slider"></span>

              </label>
            </div>

            {errors.swiftCode && (
              <small className="error-text">
                {errors.swiftCode}
              </small>
            )}
          </div> */}

          {/* SWIFT INPUT */}

          {/* {isSwift && (
            <div className="bank-input">

              <label className="pb-2">
                SWIFT / BIC
              </label>

              <input
                type="text"
                placeholder="مثال: NCBKSAJE"
                value={swiftCode}
                onChange={(e) => {
                  const value =
                    e.target.value.toUpperCase();

                  setSwiftCode(value);

                  setErrors((prev) => ({
                    ...prev,
                    swiftCode:
                      value.trim()
                        ? ""
                        : "رمز SWIFT مطلوب",
                  }));
                }}
              />
            </div>
          )} */}

          {/* IBAN */}

          {/* <div className="bank-input">

            <label className="pb-2">
              رقم (IBAN)
            </label>

            <input
              type="text"
              placeholder="SA000000000000000000"
              value={iban}
              onChange={(e) => {
                const value =
                  e.target.value.toUpperCase();

                setIban(value);

                setErrors((prev) => ({
                  ...prev,
                  iban:
                    validateIban(value),
                }));
              }}
            />

            {errors.iban && (
              <small className="error-text">
                {errors.iban}
              </small>
            )}
          </div> */}

          {/* رقم الجوال */}

          {/* <div className="bank-input">

            <label className="pb-2">
              رقم الجوال المرتبط بالحساب
            </label>

            <input
              type="text"
              placeholder="ادخل رقم الجوال"
              value={mobile}
              onChange={(e) => {
                const value =
                  e.target.value;

                setMobile(value);

                setErrors((prev) => ({
                  ...prev,
                  mobile:
                    validateMobile(
                      value
                    ),
                }));
              }}
            />

            {errors.mobile && (
              <small className="error-text">
                {errors.mobile}
              </small>
            )}
          </div> */}

          {/* رفع صورة */}

          {/* <div className="bank-input">

            <label className="pb-2">
              إثبات ملكية الحساب البنكي
            </label>

            <label className="upload-input-bank">

              <input
                type="file"
                accept="image/*"
                hidden
                onChange={(e) => {
                  if (
                    e.target.files[0]
                  ) {
                    setBankImage(
                      e.target.files[0]
                    );

                    setErrors(
                      (prev) => ({
                        ...prev,
                        bankImage: "",
                      })
                    );
                  }
                }}
              />

              <div className="upload-text">
                {bankImage
                  ? bankImage.name
                  : "اضغط هنا لرفع صورة كشف الحساب"}
              </div>

            </label>

            {errors.bankImage && (
              <small className="error-text">
                {errors.bankImage}
              </small>
            )}
          </div> */}

          {/* SUBMIT */}
{/* <input
  type="hidden"
  value={accountNumber}
/> */}
<div className="bank-input">

  <label className="pb-2">
    رقم الحساب / الفيزا
  </label>

  {!isEditing ? (

    <>
      <div className="bank-account-preview">
        **** **** **** {accountNumber.slice(-2)}
      </div>

      <button
        type="button"
        className="edit-btn"
        onClick={() => {
          setIsEditing(true);
          setSuccessMsg("");
        }}
      >
        تعديل
      </button>

    </>

  ) : (

    <>
      <input
        type="text"
        value={accountNumber}
        onChange={(e) =>{
          setAccountNumber(e.target.value)
          setShowNoChanges(false);
        }
          
        }
      />
{errors.accountNumber && (
  <small className="error-text">
    {errors.accountNumber}
  </small>
)}
          {showNoChanges && (
  <p className="error-text  d-block"> 
    لم يتم اكتشاف أي تغييرات لحفظها
  </p>
)}
      <div className="d-flex gap-3 m-auto w-50  ">

        <button
          type="submit"
          className="save-btn"
        >
          حفظ
        </button>

        <button
          type="button "
          className="cancel-btn"
          onClick={() => {
            setIsEditing(false);
          }}
        >
          إلغاء
        </button>
        <br/>

        {/* {showNoChanges && (
  <p className="error-text">
    لم يتم اكتشاف أي تغييرات لحفظها
  </p>
)} */}

      </div>
    

    </>

  )}

  {successMsg && (
    <p className="success-msg">
      {successMsg}
    </p>
  )}

</div>

          {/* <button
            className={`submit-btn ${
              isSubmitted
                ? "submitted-btn"
                : ""
            }`}
            type="submit"
          >
            {isSubmitted
              ? "قيد المراجعة"
              : "إرسال للمراجعة"}
          </button> */}
          {/* <button
  style={{
    background: isSubmitted
      ? "#ff5b0a"
      : "#0d2d63",
  }}
  className="submit-btn"
  type="submit"
>
  {isSubmitted
    ? "قيد المراجعة"
    : "إرسال للمراجعة"}
</button> */}
{/* <button
  className={`submit-btn ${
    isSubmitted ? "submitted-btn" : ""
  }`}
  type="submit"
>
  {isSubmitted
    ? "قيد المراجعة"
    : "إرسال للمراجعة"}
</button> */}
{/* <button
  className={
    isSubmitted
      ? "submit-btn submitted-btn"
      : "submit-btn"
  }
  type="submit"
>
  {isSubmitted
    ? "قيد المراجعة"
    : "إرسال للمراجعة"}
</button> */}


          {/* <p className="note-text">
            ملاحظة: سيتم تفعيل
            السحب/المدفوعات بعد ربط
            بوابة الدفع. حالياً يتم
            جمع البيانات للمراجعة فقط.
          </p> */}

        </form>
      </div>
      {showSuccessModal && (

  <div className="success-modal-overlay">

    <div className="success-modal p-5">

      <h4 className="pb-3">
        تم تحديث الحساب البنكي بنجاح
      </h4>

      <button
        onClick={() =>
          setShowSuccessModal(false)
        }
      >
        حسناً
      </button>

    </div>

  </div>

)}
    </div>
  );
}